import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createPersonAddress,
  updatePersonAddress,
} from '../store/actions/person/personActions';
import useApplicationUid from './useApplicationUid';

const usePersonAddressDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const personAddressDispatch = ({
    data,
    personUid,
    defaultValues,
    onSuccess,
    onError,
  }) => {
    const shouldSkip = isEqual(data, defaultValues);

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      PersonUid: personUid,
      data,
      onSuccess,
      onError,
    };
    if (defaultValues?.Street) {
      dispatch(
        updatePersonAddress({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createPersonAddress({
        ...requestData,
      }),
    );
  };

  return { personAddressDispatch };
};

export default usePersonAddressDispatch;
